import { EmailIcon } from '../../../assets/svg/EmailIcon';
import { InstagramIcon } from '../../../assets/svg/InstagramIcon';
import { TelegramIcon } from '../../../assets/svg/TelegramIcon';
import { SingleInfo } from './SingleInfo';
import styles from './TopFooter.module.scss';

const topFooterContent = [
  {
    id: 'tf-telegram',
    title: 'footer.communicationFindOurChannel',
    icon: TelegramIcon,
    altText: 'Telegram',
    infoLink: 'https://t.me/dityMaybutnyogo',
    infoText: 'Telegram',
  },
  {
    id: 'tf-message',
    title: 'footer.communicationWriteToUs',
    icon: EmailIcon,
    altText: 'Email',
    infoLink: 'mailto:skrinkaznan.com@gmail.com',
    infoText: 'skrinkaznan.com@gmail.com',
    isEmail: true,
  },
  {
    id: 'tf-instagrram',
    title: 'footer.communicationFollowOurPage',
    icon: InstagramIcon,
    altText: 'Instagram',
    infoLink: 'https://www.instagram.com/ditymaybutnyogo',
    infoText: 'Instagram',
  },
];

export const TopFooter = () => {
  return (
    <div className={styles.topFooterInfo}>
      <div className="row g-0">
        {topFooterContent.map(item => {
          const { id, title, icon: Icon, infoLink, infoText, isEmail } = item;

          return (
            <SingleInfo
              key={id}
              title={title}
              icon={<Icon />}
              infoLink={infoLink}
              infoText={infoText}
              isEmail={isEmail}
            />
          );
        })}
      </div>
    </div>
  );
};
